import { deviceShowState } from '@/store/deviceInfo'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useState } from 'react'
import { AiOutlineBook, AiOutlineControl, AiOutlineDesktop, AiOutlineRight } from 'react-icons/ai'
import { NavLink, useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Modal from '../Modal'
import TempClass from '../TempClass'

const menu = [
  {
    icon: <AiOutlineBook />,
    title: '我的课程',
    subitem: [
      {
        title: '我的课表',
        link: '/center',
        type: 0
      },
      {
        title: '已上课程',
        link: '/center/finish-class',
        type: 0
      }
    ]
  },
  {
    icon: <AiOutlineControl />,
    title: '设备检测',
    subitem: [
      {
        title: '在线检测',
        link: 'ittest',
        type: 2
      }
    ]
  },
  {
    icon: <AiOutlineDesktop />,
    title: '临时课堂',
    subitem: [
      {
        title: '临时课堂',
        link: 'tempclass',
        type: 2
      }
    ]
  }
]

export default () => {
  const location = useLocation()
  const [deviceShow, setDeviceShow] = useRecoilState(deviceShowState)
  const [showTempClass, setShowTempClass] = useState<boolean>(false)

  const events = (link: string) => {
    console.log(link)
    switch (link) {
      case 'ittest':
        setDeviceShow(true)
        break
      case 'tempclass':
        setShowTempClass(true)
        break
    }
  }

  return (
    <Container className="w-[160px]">
      <div className="w-full h-[140px] flex flex-col justify-center items-center border-b-[1px] border-[#e8e8e8] mb-[24px]">
        <div className="w-[74px] h-[74px] rounded-full overflow-hidden">
          <img className="w-[74px] h-[74px] rounded-full overflow-hidden object-cover" src={localStorage.head} alt="" />
        </div>
        <div className="mt-[10px] mb-[24px]">{localStorage.username}</div>
      </div>

      <ul className="m-0 p-0 list-none">
        {menu.map(({ icon, title, subitem }) => (
          <li className="group" key={title}>
            <div className="flex items-center justify-start text-[16px]">
              <div className="text-[#6a6a6a] w-[20px]">{icon}</div>
              <div className="ml-[5px] font-medium">{title}</div>
            </div>
            <ul className="m-0 p-0 list-none ml-[25px]">
              {subitem.map(({ title, link, type }) => (
                <li className={`subitem text-[14px] mt-[16px] mb-[16px] flex items-center justify-start ${location.pathname === link ? 'actives' : ''}`} key={title}>
                  {type === 0 ? (
                    <NavLink to={link} className="flex-1">
                      {title}
                    </NavLink>
                  ) : null}
                  {type === 1 ? (
                    <a className="flex-1" href={link}>
                      {title}
                    </a>
                  ) : null}
                  {type === 2 ? (
                    <span className="flex-1 cursor-pointer" onClick={() => events(link)}>
                      {title}
                    </span>
                  ) : null}
                  <AiOutlineRight />
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>

      <Modal show={showTempClass && !deviceShow} footer="" header="" cancel={() => setShowTempClass(false)}>
        <TempClass
          cancel={() => {
            setShowTempClass(false)
          }}
        />
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 20px;
  background-color: #fff;
  border-radius: 6px;
  .group {
    position: relative;
    margin-bottom: 40px;
    ::before {
      content: '';
      position: absolute;
      bottom: -20px;
      width: 100%;
      height: 1px;
      background: #ededed;
    }
    :last-child {
      ::before {
        display: none;
      }
    }
    .subitem {
      transition: all 0.15s;
      :hover {
        color: #ff3300;
      }
    }
    .actives {
      color: #ff3300;
    }
  }
`
